import styled from "styled-components";

export const QuadroSelecionados = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 20px;
  margin-bottom: 1.5rem;
  background-color: ${({ theme }) => theme.colors.neutral.neutral05};
  border-radius: 8px;

  strong {
    color: ${({ theme }) => theme.colors.neutral.neutral90};
  }
`;

export const CaixaEmails = styled.div<{ $erro: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.375rem;
  min-height: 38px;
  max-height: 160px;
  overflow-y: auto;
  padding: 0.375rem 0.5rem;
  border: 1px solid
    ${({ theme, $erro }) =>
      $erro ? theme.colors.danger.main : theme.colors.neutral.neutral20};
  border-radius: 0.375rem;
  background-color: #fff;
  cursor: text;

  &:focus-within {
    border-color: ${({ theme, $erro }) =>
      $erro ? theme.colors.danger.main : theme.colors.project.main};
  }

  input {
    flex: 1;
    min-width: 180px;
    border: 0;
    outline: none;
    font-size: 0.875rem;
  }
`;

export const ChipEmail = styled.span<{ $invalido: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
  font-size: 0.8125rem;
  background-color: ${({ theme, $invalido }) =>
    $invalido
      ? theme.colors.tags.danger.bgColor
      : theme.colors.neutral.neutral05};
  color: ${({ theme, $invalido }) =>
    $invalido
      ? theme.colors.tags.danger.textColor
      : theme.colors.neutral.neutral80};

  svg {
    font-size: 0.625rem;
    cursor: pointer;
  }
`;

export const MensagemErroEmails = styled.span`
  display: block;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.danger.main};
`;
